import { useTranslations } from "next-intl";

import { HorizontalDropdown } from "@/components/dropdown/HorizontalDropdown";
import { Icon } from "@/components/icons/Icon";
import { Sidebar } from "@/components/sidebar";

import type { DropdownItem } from "@/components/sidebar/Dropdown";

export const ALIGNMENT_OPTIONS = ["left", "center", "right"] as const;

export type Alignment = (typeof ALIGNMENT_OPTIONS)[number];

export const AlignDropdown = ({
  currentAlignment,
  tooltipTitle,
  onSelect,
}: {
  currentAlignment?: Alignment | null;
  tooltipTitle?: string;
  onSelect: (value: Alignment) => void;
}) => {
  const t = useTranslations("sidebar");
  const items = [
    {
      title: t("textStyle.alignLeft"),
      icon: <Icon name="AlignTextLeft" />,
      active: currentAlignment === "left",
      hintKey: "textAlignLeft",
      onClick: () => {
        onSelect("left");
      },
    },
    {
      title: t("textStyle.alignCenter"),
      icon: <Icon name="AlignTextCenter" />,
      active: currentAlignment === "center",
      hintKey: "textAlignCenter",
      onClick: () => {
        onSelect("center");
      },
    },
    {
      title: t("textStyle.alignRight"),
      icon: <Icon name="AlignTextRight" />,
      active: currentAlignment === "right",
      hintKey: "textAlignRight",
      onClick: () => {
        onSelect("right");
      },
    },
  ] satisfies DropdownItem[];
  const activeItem = items.find((item) => item.active);

  return (
    <HorizontalDropdown
      toggleButtonComponent={
        <Sidebar.ToggleButton
          as="div"
          icon={activeItem?.icon || <Icon name="AlignTextLeft" />}
          tooltipTitle={tooltipTitle}
          hintKey="textAlign"
        />
      }
      items={items}
    />
  );
};
